import React from 'react';
import PropTypes from 'prop-types';
import { SimpleSelectSearch, StyledLabel } from '../../FormElements';
import { useTranslation } from 'react-i18next';

const GenericPicker = ({ value, onChange, options, label }) => {
  const { t } = useTranslation();

  return (
    <>
      <div style={{ marginTop: '5px' }}>
        <StyledLabel>{t(label) + ':'}</StyledLabel>
        <SimpleSelectSearch
          onChange={onChange}
          options={options}
          value={value === -1 && options.length > 0 ? options[0].value : value}
        />
      </div>
    </>
  );
};

GenericPicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
};

export default GenericPicker;
